MS = window.MS || {};

(function( $, _m, _s ) {
	MS.masterbrand = {
		pageLoaded: false,
		init: function() {
			var _this = this;

			// enable devTools
			_m.devTools();

			// video init
			MS.video.init();

			// header and navigation init
			MS.header.init();
			MS.navigation.init();
			MS.foodwaste.init();
      MS.footer.init();

			_this.sharing();

			// hero,social carousel init
			_this.carouselHandler();

			// influencer gallery init
			_this.influencerGalleryHandler();

			// parallax init
			_this.parallaxHandler();

			_this.contentAnimationHandler();

			// announcement init
			_this.announcementHandler();

			// run init.s after dom content loaded
			_m.ready( function() {
				// scroll to next section init
				_this.scrollToHandler();
				_this.shareScrollHandler();

				// influencer expand/collapse init
				_this.influencerHandler();

				// announcement expand/collapse init
				_this.announcementHandler();

				_this.waypointHandler();


				//scroll to shared
				var sharedInfluencer = document.querySelector( '.shared' );
				var sharedStory = document.querySelector( '.shared-story' );
	            if ( sharedInfluencer ) {
	                MS.loader.show();

	                var target = sharedInfluencer.children[0].children[0].children[3];
	                $('.ms-module--influencer .ms-module-wrapper').addClass( 'animated quick-view' );

					_m.when(function condition(){
						return ( sharedInfluencer.classList.contains('expanded') );
					}, function code(){
						setTimeout(function(){
							_m.jump( target, { duration: 1 } );
							$('.ms-module--influencer .ms-module-wrapper').removeClass( 'quick-view' );
	                    	MS.loader.hide();
						}, 1000);
					});
				} else if ( sharedStory ) {
					MS.loader.show();
					setTimeout(
						function() {
							_m.jump( 'shared-story', { duration: 10 } );
	                    	MS.loader.hide();
						}, 2000);
	            } else { // scroll page to top after page load/reload
					_m.jump( 'page', { duration: 10 } );
	            }
			});
		},
		influencerHandler: function() {
			if ( !$('.ms-influencer-trigger').length ) { return false; }

			var _this = this;
			var _elTrigger = document.querySelectorAll( '.ms-influencer-trigger');
			var _elModule = _m.getParents(_elTrigger[0], '.ms-module')[0];
			var _elTarget = [];
			var _elTargetContent = [];
			var _elContainer = [];
			var _frames = [];
			var _elBelow = _m.getSiblings(_elModule, 'next');
			var _elAbove = _m.getSiblings(_elModule, 'prev');

			_elAbove.push( document.querySelector('.ms-module--influencer__introduction') );

			// curtain animation handler
			// toggle open or close dom elements as panels (vertically)
			var curtain = {
				started : false, // animation starting: 0,false/1,true
				state : 'idle', // idle/opening/closing
				action : 'idle', // none/open/close
				task : null, // 1 = open, 0 = close
				index : null,
				fromTop : [],
				fromBottom : [],
				activeIndex : null,
				midScrollTo : null,
				sm : window.matchMedia( "( max-width: 400px )" ),
				md : window.matchMedia( "( min-width: 401px && max-width: 860px )" ),
				lg : window.matchMedia( "( min-width: 861px && max-width: 1200px )" ),
				windowHeight : 0,

				reset : function() {
					var _c = this;
					var _i = _c.index;

					_c.state = 'idle';
					_c.action = 'idle';
					_c.midScrollTo = _c.task ? _c.midScrollTo : null;

					var properties = /(started|fromTop|fromBottom|toStay)/g;
					for ( var property in _c ) {
						if ( property.match( properties ) ) {
							_c[property] = _c[property].constructor();
						}
					}

					Waypoint.refreshAll();
					if ( _c.task && _elTarget[_i].getBoundingClientRect().top <= 60 ) {
						_elTrigger[_i].classList.add( 'stick' );
						_elTarget[_i].classList.add( 'mid-collapse' );
					}

					setTimeout(function () {
						_c.activeIndex = _c.task ? _c.index : null;
						_c.index = null;
					}, 10);

					var on = _m.scroll.on;
				},

				// prepare curtain animation
				prepare : function() {
					var _c = this;
					var _i = _c.index;
					var _ctr = 0;
					var nodes = []; // temporary array
					if ( curtain.started ) { _c.warn(); }

					// monitor sequential task, run curtain.operate when completed
					_m.when(function condition(){
						return ( curtain.started );
					}, function code(){
						_c.operate();
					});

					// sequencial task: add nodes to fromBottom array
					var sequence = [
						// get containers below current the container
						// of the trigger & target
						function ( callback ) {
							_ctr = _elContainer.length;
							while( _ctr-- ) {
								if ( _ctr > _i ) {
									_c.fromBottom.push( _elContainer[_ctr] );
								} else {
									_c.fromTop.push( _elContainer[_ctr].children[0] );
								}
								if ( _ctr < 0 || _ctr === 0 ) {
									callback();
									break;
								}
							}
						},
						// get medules below and above the influencer module
						function( callback ) {
							_ctr = _elBelow.length;
							while( _ctr-- ) {
								_c.fromBottom.push( _elBelow[_ctr] );
								if ( _ctr < 0 || _ctr === 0 ) {
									callback();
									break;
								}
							}
							_ctr = _elAbove.length;
							while( _ctr-- ) {
								_c.fromTop.push( _elAbove[_ctr] );
								if ( _ctr < 0 || _ctr === 0 ) {
									callback();
									break;
								}
							}
						},
						function( callback ) {
							if ( _c.action.match( /open/g ) ) {
								_c.state = 'opening';
								_c.task = 1;
							} else if ( _c.action.match( /close/g ) ) {
								_c.state = 'closing';
								_c.task = 0;
							}
							setTimeout(function () {
								callback();
							}, 100);
						}
					];

					// call back after the sequential task
					_m.runSequence(sequence, function() {
						curtain.started = true;
					});
				},

				// verify options
				// @param {nodes} array of html elements
				// @param {option} class/attribute
				// @param {string} identifier
				verify : function( nodes, option, string ) {
					var _ctr = nodes.length;
					var result = 0;
					while( _ctr-- ) {
						if ( option.match( /attribute/g ) && nodes[_ctr].hasAttribute(string) ) {
							result++;
						} else if ( option.match( /class/g ) && nodes[_ctr].classList.contains(string) ) {
							result++;
						}
					}
					return result;
				},

				// animation action: open/close
				operate : function() {
					var _c = this;
					var _i = _c.index;
					var _ctr = 0;
					var nodes = []; // temporary array
					var movePlus = _c.sm.matches ? 144 : _c.md.matches ? 144 : 210;

					// if no defined index, exit
					if ( !_i || _c.action.match( /idle/g ) ) {
						_c.reset();
						return;
					}

					if ( !_c.task ) {
						var base = _i < _elContainer.length - 1 ? _elContainer[Math.abs(_i)+1] : _elBelow[0];
						var baseTop = base.getBoundingClientRect().top;

						_c.midScrollTo = _m.getElemDistance(base);
						_c.midScrollTo -= _elTarget[_i].offsetHeight - movePlus;

						if ( _elTarget[_i].getBoundingClientRect().bottom <= _c.windowHeight ) {
							_c.midScrollTo -= baseTop;
						} else {
							_c.midScrollTo -= _c.windowHeight * 0.8;
						}
					}

					// add expand-start/collapse-start class
					var classString = _c.task ? 'expand' : 'collapse';
					_elTarget[_i].classList.add(  classString + '-start' );
					_elContainer[_i].classList.add(  classString + '-start' );

					// remove current collapsed/expanded class
					classString = _c.task ? 'collapsed' : 'expanded';
					_elTarget[_i].classList.remove( classString );
					_elContainer[_i].classList.remove( classString );

					// cache styles, to be applied, on data-style-set attribute
					nodes = nodes.concat(
						_frames,
						_c.fromBottom,
						_c.fromTop
					);
					nodes.push( _elTarget[_i] );
					_c.defineStyleSet( nodes );

					_elTargetContent[_c.index].setAttribute('data-style-set', JSON.stringify({
						position: 'relative'
					}));
					nodes.push( _elTargetContent[_i] );

					if ( _elTarget[_i].classList.contains( 'mid-collapse' ) ) {
						_elTrigger[_i].style.opacity = '0';
					}

					var allNodesValid = false;
					_m.when(function condition(){
						var valid = 0;

						// check if the data-style-set attribute is set
						valid += _c.verify( nodes, 'attribute', 'data-style-set' );

						if ( valid === nodes.length ) {
							allNodesValid = true;
						}
						return ( allNodesValid );
					}, function code(){
						setTimeout(function() {
							_c.moveNodes();
						}, 100);
					});
				},

				// animation ended
				end : function() {
					var _c = this;
					var _i = _c.index;
					var _ctr = 0;
					var nodes = []; // temporary array

					if ( !_i ) {
						return;
					}

					_c.state = 'ending';

					nodes = nodes.concat(
						_elTarget,
						_elTargetContent,
						_elContainer,
						_elBelow,
						_elAbove,
						_frames,
						_c.fromBottom,
						_c.fromTop
					);

					_ctr = nodes.length;
					while( _ctr-- ) {
						if ( _ctr < 0 ) { break; }
						nodes[_ctr].setAttribute( 'style', '' );
						nodes[_ctr].setAttribute( 'data-style-set', '' );

						nodes[_ctr].removeAttribute( 'style');
						nodes[_ctr].removeAttribute( 'data-style-set');
					}

					_ctr = _c.fromBottom.length;
					while( _ctr-- ) {
						if ( _ctr < 0 ) { break; }
						_c.fromBottom[_ctr].classList.remove( 'animated' );
					}

					_ctr = _c.fromTop.length;
					while( _ctr-- ) {
						if ( _ctr < 0 ) { break; }
						_c.fromTop[_ctr].classList.remove( 'animated' );
					}

					var classString = _c.task ? 'expand' : 'collapse';
					_elTarget[_i].classList.add( classString + ( _c.task ? 'ed' : 'd' ) );

					_elTarget[_i].classList.remove( classString + '-start' );
					_elTarget[_i].classList.remove( 'animated' );

					_elContainer[_i].classList.remove( classString + '-start' );
					_elContainer[_i].classList.add( classString + ( _c.task ? 'ed' : 'd' ) );

					if ( _elTarget[_i].classList.contains( 'mid-collapse' ) ) {
						window.scrollTo(0,_c.midScrollTo);
						_elTarget[_i].classList.remove( 'mid-collapse' );
					}

					$('.ms-ts-gallery-module__images').slick('setPosition');

					_elTrigger[_i].btn.state = _c.task ? 1 : 0;
					_elTrigger[_i].removeAttribute( 'disabled' );
					_elTrigger[_i].removeAttribute( 'style' );

					MS.inlineVideo.close($(_elTargetContent));

					setTimeout(function() {
						_c.reset();
						_elTarget[_i].removeAttribute( 'style' );
					}, 200);
				},

				moveNodes : function() {
					var _c = this;
					var _i = _c.index;
					var _ctr = 0;

					var sm = _c.sm;
					var md = _c.md;
					var lg = _c.lg;
					var moveY = 0;
					var base = _elContainer[_i].children[0];
					var currentPosition = 0;
					var moveYbottom = 0;
					var offsetStart = 0;
					var offsetBottom = 0;
					var movePlus = sm.matches ? 144 : md.matches ? 144 : 210;
					var nodes = [];

					_m.runSequence([
						// apply css set to _frames
						function (callback) {
							_c.applySet( _frames, /height/g );

							setTimeout(function () {
								callback();
							}, 50);
						},

						function (callback) {

							_c.applySet( _c.fromBottom );
							if ( _elTarget[_i].classList.contains( 'mid-collapse' ) ) {
								nodes = nodes.concat( _c.fromTop, _elTarget[_i] );
								_c.applySet( nodes );
							}

							var allNodesValid = false;
							_m.when(function condition(){
								var valid = 0;
								var total = 0;

								valid += _c.verify( _c.fromBottom, 'attribute', 'style' );

								if ( valid === _c.fromBottom.length ) {
									allNodesValid = true;
								}
								return ( allNodesValid );
							}, function code(){
								setTimeout(function () {
									if ( _elTarget[_i].getBoundingClientRect().bottom < 0 || _elTarget[_i].getBoundingClientRect().top > _c.windowHeight ) {
										setTimeout(function () {
											_c.end();
										}, 100);
									} else {
										callback();
									}
								}, 50);
							});
						},
						function (callback) {
							moveY = _c.windowHeight - base.getBoundingClientRect().bottom;
							offsetBottom = _elTargetContent[_i].getBoundingClientRect().bottom;

							// get bottom and top of viewport as starting point
							offsetStartBottom = _elTargetContent[_i].offsetHeight - (_c.windowHeight -  _elTargetContent[_i].getBoundingClientRect().top);
							offsetStartBottom = offsetBottom > _c.windowHeight ? offsetStartBottom : 0;
							offsetStartTop = Math.abs(_elTargetContent[_i].getBoundingClientRect().top) - movePlus;

							_elTargetContent[_i].style.position = 'relative';

							setTimeout(function () {
								callback();
							}, 50);
						},
						// set top and bottom of viewport as starting point of elements before animation
						function (callback) {
							if ( !_c.task ) {
								_ctr = _c.fromBottom.length;
								while( _ctr-- ) {
									currentPosition = Math.abs(_c.fromBottom[_ctr].style.top.split('px')[0]);
									_c.fromBottom[_ctr].style.top = (currentPosition - offsetStartBottom) + 'px';
								}

								if ( _elTarget[_i].classList.contains( 'mid-collapse' ) ) {
									_ctr = _c.fromTop.length;
									while( _ctr-- ) {
										if ( _ctr < 0 ) { break; }
										currentPosition = Math.abs(_c.fromTop[_ctr].style.top.split('px')[0]);
										_c.fromTop[_ctr].style.top = -Math.abs(currentPosition - offsetStartTop) + 'px';
									}
									// position the expanded influencer to avoid overlapping on moving nodes
									_elTarget[_i].style.zIndex = '-10';
								}
							}

							setTimeout(function () {
								callback();
							}, 50);
						}
					], function() {

						// if collapse is triggered on the middle of the expanded influencer
						if ( _elTarget[_i].classList.contains( 'mid-collapse' ) ) {

							// set then animate nodes above the expanded content
							_ctr = _c.fromTop.length;
							while( _ctr-- ) {
								if ( _ctr < 0 ) { break; }
								_c.fromTop[_ctr].style.backgroundColor = 'white';
								_c.moveElement(
									_c.fromTop[_ctr],
									offsetBottom > _c.windowHeight ? (_c.windowHeight * 0.8) : offsetBottom,
									{
										duration: 200
									}
								);
							}
							// set then animate nodes below the expanded content
							_ctr = _c.fromBottom.length;
							while( _ctr-- ) {
								if ( _ctr < 0 ) { break; }
								_c.fromBottom[_ctr].classList.add( 'fromBottom' );
								_c.moveElement(
									_c.fromBottom[_ctr],
									offsetBottom > _c.windowHeight ? (_c.windowHeight * 0.2) : 0,
									{
										duration: 100,
										easing: _m.easing.easeInQuad
									}
								);
							}

						// for collpase and expand, set then animate nodes
						} else {
							_ctr = _c.fromBottom.length;
							while( _ctr-- ) {
								if ( _ctr < 0 ) { break; }

								_c.moveElement( _c.fromBottom[_ctr], moveY, {
									duration: 200
								});
							}
							_c.moveElement( _elTarget[_i], movePlus, {
								duration: 100,
								easing: _m.easing.easeInQuad
							});
						}
					});

					var allNodesValid = false;
					_m.when(function condition(){
						var q = _c.fromBottom.length;
						var valid = 0;
						var classString = 'animated';

						// check if all has animated class
						valid += _c.verify( _c.fromBottom, 'class', classString );

						if ( valid === _c.fromBottom.length ) {
							allNodesValid = true;
						}
						return ( allNodesValid );
					}, function code(){
						setTimeout(function () {
							if( _i ) {
								_c.end();
							}
						}, 100);
					});
				},

				// curtain animation handler
				// move elements up or down
				// @param {node} target The element
				// @param {number} destination Negative integers for up, Positive integers for down
				// @param {object} options Overwrite default options
				moveElement : function(target, destination, option) {
					var _c = this;
					var _i = _c.index;
					var timeStart = null;
					var timeElapsed;
					var duration = 800 || option.duration;
					var easing = _m.easing.easeInOutCubic || option.easing;
					var distance = destination;
					var start = 0;
					var move = 0;
					var moveTo = 0;
					var rafID;
					var classString = _c.task ? 'expanding' : 'collapsing';

					target.classList.remove( 'animated' );
					target.classList.add( 'animating' );

					target.classList.add( classString );

					function loopEnd() {
						move = start + distance;
						cancelAnimationFrame(rafID);

						target.style.transfrom = 'matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,' + move + ',0.001,1)';

  						target.classList.remove( 'fromBottom' );
						target.classList.remove( classString );

						target.classList.remove( 'animating' );
						target.classList.add( 'animated' );
					}

					function loop(time) {
						timeElapsed = time - timeStart;

						move = Math.abs(easing(timeElapsed, start, distance, duration));

						// if collapse is triggered on the middle of the expanded influencer
						if( _elTarget[_i].classList.contains( 'mid-collapse' ) && !_c.task ) {
							if ( target.classList.contains( 'fromBottom' ) ) {
								moveTo = -Math.abs(move);
							} else {
								moveTo = Math.abs(move);
							}
						} else {
							moveTo = _c.task ? Math.abs(move) : -Math.abs(move);
							if( target === _elTarget[_i] ) {
								moveTo = _c.task ? -Math.abs(move) : Math.abs(move);
							}
						}

						target.style.transform = 'matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,' + moveTo + ',0.001,1)';

						if ( timeElapsed < duration ) {
							rafID = requestAnimationFrame(loop);
						} else {
							loopEnd();
						}
					}

					setTimeout(function () {
						rafID = requestAnimationFrame(function(time) { timeStart = time; loop(time); });
					}, 100);
				},

				// apply styles based on data-style-set attribute
				// @param {node} el Element with data-style-set attribute
				applySet : function(el, rule) {
					if  ( !(typeof el).match(/object/g) ) {
						var node = el;
						el = [];
						el.push(node);
					}

					var q = el.length;
					var max = el.length;
					while( q-- ) {
						if ( q < 0 ) { break; }
						var style = el[q].style;
						var set = JSON.parse(el[q].getAttribute('data-style-set'));
						var css = rule || /(top|left|height|width|position)/g;
						for ( var prop in set ) {
							if (prop.match(css)) {
								style[prop] = set[prop];
							}
						}
					}
				},

				// set styles and cache on data-style-set attribute
				// @param {array} arr array of nodes
				defineStyleSet : function(arr) {
					if  ( !(typeof arr).match(/object/g) ) {
						var node = arr;
						arr = [];
						arr.push(node);
					}

					var q = arr.length;
					var max = arr.length;
					while( q-- ) {
						if ( q < 0 ) {
							break;
						}
						var s = arr[q].getBoundingClientRect();
						arr[q].setAttribute('data-style-set', JSON.stringify({
							top : String(s.top + 'px'),
							left : String(s.left + 'px'),
							width : String(s.width + 'px'),
							height : String(s.height + 'px'),
							position : 'fixed'
						}));
					}
				},

				warn : function() {
					var _c = this;

					console.warn('curtain is ' + _c.state + '!');
					return;
				}
			};

			// init curtain triggers
			var curtainInit = function( e ) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();

				var off = _m.scroll.off;
				curtain.windowHeight = window.innerHeight || document.documentElement.clientHeight;

				// if curtain is not idle, animation cancel
				if ( curtain.started ) { curtain.warn(); return; }

				var _trigger = this;
				var _index = _trigger.getAttribute( 'data-index' );

				_trigger.setAttribute('disabled', '');
				_trigger.style.zIndex = '10';

				if ( curtain.activeIndex !== null && _index !== curtain.activeIndex ) {
					curtain.index = curtain.activeIndex;

					// if trigger state is 0/false, curtain action is open
					curtain.action = _elTrigger[ curtain.activeIndex ].btn.state ? 'close' : 'open';

					// prepare curtain animation
					curtain.prepare();
				}

				// monitor sequential task, run curtain.operate when completed
				_m.when(function condition(){
					var indx = curtain.activeIndex === null ? true : _index === curtain.activeIndex ? true : false;

					return indx;
				}, function code(){
					setTimeout(function () {
						curtain.index = _index;
						curtain.action = _trigger.btn.state ? 'close' : 'open';
						curtain.prepare();
					}, 200);
				});
			};

			// click listener
			var clickListener = function( _el ) {
				// bind click to triggers
				_el.addEventListener( 'click', curtainInit, false );
			};

			// add window/browser resize listener
			window.addEventListener("resize",  _m.debounce( function() {
				curtain.sm = window.matchMedia( "( max-width: 400px )" );
				curtain.md = window.matchMedia( "( min-width: 401px && max-width: 860px )" );
				curtain.lg = window.matchMedia( "( min-width: 861px && max-width: 1200px )" );
			}, 200));

			// cache frames
			_frames.push( document.querySelector( 'HTML' ) );
			_frames.push( document.querySelector( 'body' ) );
			_frames.push( document.querySelector( '.site-container' ) );

			// init bind click to triggers
			var total = _elTrigger.length;
			while( total-- ) {
				if ( total < 0) { break; }

				// add btn data
				_elTrigger[total].btn = {
					state: 0
				};

				//cache trigger container : li classname = ms-module--influencer__list-item
				_elContainer[total] = _m.getParents( _elTrigger[total], 'li' )[0];

				//cache target : article classname = ms-influencer-info
				_elTarget[total] = _elTrigger[total].parentNode.nextElementSibling;
				_elTarget[total].classList.add( 'collapsed' );

				//cache target content : div classname = ms-influencer-info__content
				_elTargetContent[total] = _elTarget[total].firstElementChild;

				// Add index on trigger and target and container
				_elContainer[total].setAttribute( 'data-index', total );
				_elTrigger[total].setAttribute( 'data-index', total );
				_elTarget[total].setAttribute( 'data-index', total );

				// add click listener on trigger
				clickListener(_elTrigger[total]);
			}

			var sharedInfluencer = document.querySelector( '.shared' );
			var index = sharedInfluencer ? sharedInfluencer.getAttribute( 'data-index' ) : false;
			if ( index ) {
				curtain.index = index;

				curtain.action = _elTrigger[ index ].btn.state ? 'close' : 'open';

				setTimeout(function () {
					curtain.prepare();
				}, 1500);
			}
		},
		announcementHandler: function() {
			if (!$('.ms-module--announcement').length) { return; }

			var _this = this;
			var _elTrigger = document.querySelectorAll( '.ms-announcement-trigger');
			var _elModule = _m.getParents(_elTrigger[0], '.ms-module')[0];
			var _elTarget = [];
			var _elTargetContent = [];
			var _elContainer = [];
			var _frames = [];
			var _elBelow = _m.getSiblings(_elModule, 'next');
			var _elAbove = _m.getSiblings(_elModule, 'prev');

			_elAbove.push( document.querySelector('.ms-module--announcement') );

			// curtain animation handler
			// toggle open or close dom elements as panels (vertically)
			var curtain = {
				started : false, // animation starting: 0,false/1,true
				state : 'idle', // idle/opening/closing
				action : 'idle', // none/open/close
				task : null, // 1 = open, 0 = close
				index : null,
				fromTop : [],
				fromBottom : [],
				activeIndex : null,
				midScrollTo : null,
				sm : window.matchMedia( "( max-width: 400px )" ),
				md : window.matchMedia( "( min-width: 401px && max-width: 860px )" ),
				lg : window.matchMedia( "( min-width: 861px && max-width: 1200px )" ),
				windowHeight : 0,

				reset : function() {
					var _c = this;
					var _i = _c.index;

					_c.state = 'idle';
					_c.action = 'idle';
					_c.midScrollTo = _c.task ? _c.midScrollTo : null;

					var properties = /(started|fromTop|fromBottom|toStay)/g;
					for ( var property in _c ) {
						if ( property.match( properties ) ) {
							_c[property] = _c[property].constructor();
						}
					}

					Waypoint.refreshAll();
					if ( _c.task && _elTarget[_i].getBoundingClientRect().top <= 60 ) {
						_elTrigger[_i].classList.add( 'stick' );
						_elTarget[_i].classList.add( 'mid-collapse' );
					}

					setTimeout(function () {
						_c.activeIndex = _c.task ? _c.index : null;
						_c.index = null;
					}, 10);

					var on = _m.scroll.on;
				},

				// prepare curtain animation
				prepare : function() {
					var _c = this;
					var _i = _c.index;
					var _ctr = 0;
					var nodes = []; // temporary array
					if ( curtain.started ) { _c.warn(); }

					// monitor sequential task, run curtain.operate when completed
					_m.when(function condition(){
						return ( curtain.started );
					}, function code(){
						_c.operate();
					});

					// sequencial task: add nodes to fromBottom array
					var sequence = [
						// get containers below current the container
						// of the trigger & target
						function ( callback ) {
							_ctr = _elContainer.length;
							while( _ctr-- ) {
								if ( _ctr > _i ) {
									_c.fromBottom.push( _elContainer[_ctr] );
								} else {
									_c.fromTop.push( _elContainer[_ctr].children[0] );
								}
								if ( _ctr < 0 || _ctr === 0 ) {
									callback();
									break;
								}
							}
						},
						// get medules below and above the announcement module
						function( callback ) {
							_ctr = _elBelow.length;
							while( _ctr-- ) {
								_c.fromBottom.push( _elBelow[_ctr] );
								if ( _ctr < 0 || _ctr === 0 ) {
									callback();
									break;
								}
							}
							_ctr = _elAbove.length;
							while( _ctr-- ) {
								_c.fromTop.push( _elAbove[_ctr] );
								if ( _ctr < 0 || _ctr === 0 ) {
									callback();
									break;
								}
							}
						},
						function( callback ) {
							if ( _c.action.match( /open/g ) ) {
								_c.state = 'opening';
								_c.task = 1;
							} else if ( _c.action.match( /close/g ) ) {
								_c.state = 'closing';
								_c.task = 0;
							}
							setTimeout(function () {
								callback();
							}, 100);
						}
					];

					// call back after the sequential task
					_m.runSequence(sequence, function() {
						curtain.started = true;
					});
				},

				// verify options
				// @param {nodes} array of html elements
				// @param {option} class/attribute
				// @param {string} identifier
				verify : function( nodes, option, string ) {
					var _ctr = nodes.length;
					var result = 0;
					while( _ctr-- ) {
						if ( option.match( /attribute/g ) && nodes[_ctr].hasAttribute(string) ) {
							result++;
						} else if ( option.match( /class/g ) && nodes[_ctr].classList.contains(string) ) {
							result++;
						}
					}
					return result;
				},

				// animation action: open/close
				operate : function() {
					var _c = this;
					var _i = _c.index;
					var _ctr = 0;
					var nodes = []; // temporary array
					var movePlus = _c.sm.matches ? 144 : _c.md.matches ? 144 : 195;

					// if no defined index, exit
					if ( !_i || _c.action.match( /idle/g ) ) {
						_c.reset();
						return;
					}

					if ( !_c.task ) {
						var base = _i < _elContainer.length - 1 ? _elContainer[Math.abs(_i)+1] : _elBelow[0];
						var baseTop = base.getBoundingClientRect().top;

						_c.midScrollTo = _m.getElemDistance(base);
						_c.midScrollTo -= _elTarget[_i].offsetHeight - movePlus;

						if ( _elTarget[_i].getBoundingClientRect().bottom <= _c.windowHeight ) {
							_c.midScrollTo -= baseTop;
						} else {
							_c.midScrollTo -= _c.windowHeight * 0.8;
						}
					}

					// add expand-start/collapse-start class
					var classString = _c.task ? 'expand' : 'collapse';
					_elTarget[_i].classList.add(  classString + '-start' );
					_elContainer[_i].classList.add(  classString + '-start' );

					// remove current collapsed/expanded class
					classString = _c.task ? 'collapsed' : 'expanded';
					_elTarget[_i].classList.remove( classString );
					_elContainer[_i].classList.remove( classString );

					// cache styles, to be applied, on data-style-set attribute
					nodes = nodes.concat(
						_frames,
						_c.fromBottom,
						_c.fromTop
					);
					nodes.push( _elTarget[_i] );
					_c.defineStyleSet( nodes );

					_elTargetContent[_c.index].setAttribute('data-style-set', JSON.stringify({
						position: 'relative'
					}));
					nodes.push( _elTargetContent[_i] );

					if ( _elTarget[_i].classList.contains( 'mid-collapse' ) ) {
						_elTrigger[_i].style.opacity = '0';
					}

					var allNodesValid = false;
					_m.when(function condition(){
						var valid = 0;

						// check if the data-style-set attribute is set
						valid += _c.verify( nodes, 'attribute', 'data-style-set' );

						if ( valid === nodes.length ) {
							allNodesValid = true;
						}
						return ( allNodesValid );
					}, function code(){
						setTimeout(function() {
							_c.moveNodes();
						}, 100);
					});
				},

				// animation ended
				end : function() {
					var _c = this;
					var _i = _c.index;
					var _ctr = 0;
					var nodes = []; // temporary array

					if ( !_i ) {
						return;
					}

					_c.state = 'ending';

					nodes = nodes.concat(
						_elTarget,
						_elTargetContent,
						_elContainer,
						_elBelow,
						_elAbove,
						_frames,
						_c.fromBottom,
						_c.fromTop
					);

					_ctr = nodes.length;
					while( _ctr-- ) {
						if ( _ctr < 0 ) { break; }
						nodes[_ctr].setAttribute( 'style', '' );
						nodes[_ctr].setAttribute( 'data-style-set', '' );

						nodes[_ctr].removeAttribute( 'style');
						nodes[_ctr].removeAttribute( 'data-style-set');
					}

					_ctr = _c.fromBottom.length;
					while( _ctr-- ) {
						if ( _ctr < 0 ) { break; }
						_c.fromBottom[_ctr].classList.remove( 'animated' );
					}

					_ctr = _c.fromTop.length;
					while( _ctr-- ) {
						if ( _ctr < 0 ) { break; }
						_c.fromTop[_ctr].classList.remove( 'animated' );
					}

					var classString = _c.task ? 'expand' : 'collapse';
					_elTarget[_i].classList.add( classString + ( _c.task ? 'ed' : 'd' ) );

					_elTarget[_i].classList.remove( classString + '-start' );
					_elTarget[_i].classList.remove( 'animated' );

					_elContainer[_i].classList.remove( classString + '-start' );
					_elContainer[_i].classList.add( classString + ( _c.task ? 'ed' : 'd' ) );

					if ( _elTarget[_i].classList.contains( 'mid-collapse' ) ) {
						window.scrollTo(0,_c.midScrollTo);
						_elTarget[_i].classList.remove( 'mid-collapse' );
					}

					$('.ms-ts-gallery-module__images').slick('setPosition');

					_elTrigger[_i].btn.state = _c.task ? 1 : 0;
					_elTrigger[_i].removeAttribute( 'disabled' );
					_elTrigger[_i].removeAttribute( 'style' );

					MS.inlineVideo.close($(_elTargetContent));

					setTimeout(function() {
						_c.reset();
						_elTarget[_i].removeAttribute( 'style' );
					}, 200);
				},

				moveNodes : function() {
					var _c = this;
					var _i = _c.index;
					var _ctr = 0;

					var sm = _c.sm;
					var md = _c.md;
					var lg = _c.lg;
					var moveY = 0;
					var base = _elContainer[_i].children[0];
					var currentPosition = 0;
					var moveYbottom = 0;
					var offsetStart = 0;
					var offsetBottom = 0;
					var movePlus = sm.matches ? 144 : md.matches ? 144 : 210;
					var nodes = [];

					_m.runSequence([
						// apply css set to _frames
						function (callback) {
							_c.applySet( _frames, /height/g );

							setTimeout(function () {
								callback();
							}, 50);
						},

						function (callback) {

							_c.applySet( _c.fromBottom );
							if ( _elTarget[_i].classList.contains( 'mid-collapse' ) ) {
								nodes = nodes.concat( _c.fromTop, _elTarget[_i] );
								_c.applySet( nodes );
							}

							var allNodesValid = false;
							_m.when(function condition(){
								var valid = 0;
								var total = 0;

								valid += _c.verify( _c.fromBottom, 'attribute', 'style' );

								if ( valid === _c.fromBottom.length ) {
									allNodesValid = true;
								}
								return ( allNodesValid );
							}, function code(){
								setTimeout(function () {
									if ( _elTarget[_i].getBoundingClientRect().bottom < 0 || _elTarget[_i].getBoundingClientRect().top > _c.windowHeight ) {
										setTimeout(function () {
											_c.end();
										}, 100);
									} else {
										callback();
									}
								}, 50);
							});
						},
						function (callback) {
							moveY = _c.windowHeight - base.getBoundingClientRect().bottom;
							offsetBottom = _elTargetContent[_i].getBoundingClientRect().bottom;

							// get bottom and top of viewport as starting point
							offsetStartBottom = _elTargetContent[_i].offsetHeight - (_c.windowHeight -  _elTargetContent[_i].getBoundingClientRect().top);
							offsetStartBottom = offsetBottom > _c.windowHeight ? offsetStartBottom : 0;
							offsetStartTop = Math.abs(_elTargetContent[_i].getBoundingClientRect().top) - movePlus;

							_elTargetContent[_i].style.position = 'relative';

							setTimeout(function () {
								callback();
							}, 50);
						},
						// set top and bottom of viewport as starting point of elements before animation
						function (callback) {
							if ( !_c.task ) {
								_ctr = _c.fromBottom.length;
								while( _ctr-- ) {
									currentPosition = Math.abs(_c.fromBottom[_ctr].style.top.split('px')[0]);
									_c.fromBottom[_ctr].style.top = (currentPosition - offsetStartBottom) + 'px';
								}

								if ( _elTarget[_i].classList.contains( 'mid-collapse' ) ) {
									_ctr = _c.fromTop.length;
									while( _ctr-- ) {
										if ( _ctr < 0 ) { break; }
										currentPosition = Math.abs(_c.fromTop[_ctr].style.top.split('px')[0]);
										_c.fromTop[_ctr].style.top = -Math.abs(currentPosition - offsetStartTop) + 'px';
									}
									// position the expanded announcement to avoid overlapping on moving nodes
									_elTarget[_i].style.zIndex = '-10';
								}
							}

							setTimeout(function () {
								callback();
							}, 50);
						}
					], function() {

						// if collapse is triggered on the middle of the expanded announcement
						if ( _elTarget[_i].classList.contains( 'mid-collapse' ) ) {

							// set then animate nodes above the expanded content
							_ctr = _c.fromTop.length;
							while( _ctr-- ) {
								if ( _ctr < 0 ) { break; }
								_c.fromTop[_ctr].style.backgroundColor = 'white';
								_c.moveElement(
									_c.fromTop[_ctr],
									offsetBottom > _c.windowHeight ? (_c.windowHeight * 0.8) : offsetBottom,
									{
										duration: 200
									}
								);
							}
							// set then animate nodes below the expanded content
							_ctr = _c.fromBottom.length;
							while( _ctr-- ) {
								if ( _ctr < 0 ) { break; }
								_c.fromBottom[_ctr].classList.add( 'fromBottom' );
								_c.moveElement(
									_c.fromBottom[_ctr],
									offsetBottom > _c.windowHeight ? (_c.windowHeight * 0.2) : 0,
									{
										duration: 100,
										easing: _m.easing.easeInQuad
									}
								);
							}

						// for collpase and expand, set then animate nodes
						} else {
							_ctr = _c.fromBottom.length;
							while( _ctr-- ) {
								if ( _ctr < 0 ) { break; }

								_c.moveElement( _c.fromBottom[_ctr], moveY, {
									duration: 200
								});
							}
							_c.moveElement( _elTarget[_i], movePlus, {
								duration: 100,
								easing: _m.easing.easeInQuad
							});
						}
					});

					var allNodesValid = false;
					_m.when(function condition(){
						var q = _c.fromBottom.length;
						var valid = 0;
						var classString = 'animated';

						// check if all has animated class
						valid += _c.verify( _c.fromBottom, 'class', classString );

						if ( valid === _c.fromBottom.length ) {
							allNodesValid = true;
						}
						return ( allNodesValid );
					}, function code(){
						setTimeout(function () {
							if( _i ) {
								_c.end();
							}
						}, 100);
					});
				},

				// curtain animation handler
				// move elements up or down
				// @param {node} target The element
				// @param {number} destination Negative integers for up, Positive integers for down
				// @param {object} options Overwrite default options
				moveElement : function(target, destination, option) {
					var _c = this;
					var _i = _c.index;
					var timeStart = null;
					var timeElapsed;
					var duration = 800 || option.duration;
					var easing = _m.easing.easeInOutCubic || option.easing;
					var distance = destination;
					var start = 0;
					var move = 0;
					var moveTo = 0;
					var rafID;
					var classString = _c.task ? 'expanding' : 'collapsing';

					target.classList.remove( 'animated' );
					target.classList.add( 'animating' );

					target.classList.add( classString );

					function loopEnd() {
						move = start + distance;
						cancelAnimationFrame(rafID);

						target.style.transfrom = 'matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,' + move + ',0.001,1)';

  						target.classList.remove( 'fromBottom' );
						target.classList.remove( classString );

						target.classList.remove( 'animating' );
						target.classList.add( 'animated' );
					}

					function loop(time) {
						timeElapsed = time - timeStart;

						move = Math.abs(easing(timeElapsed, start, distance, duration));

						// if collapse is triggered on the middle of the expanded announcement
						if( _elTarget[_i].classList.contains( 'mid-collapse' ) && !_c.task ) {
							if ( target.classList.contains( 'fromBottom' ) ) {
								moveTo = -Math.abs(move);
							} else {
								moveTo = Math.abs(move);
							}
						} else {
							moveTo = _c.task ? Math.abs(move) : -Math.abs(move);
							if( target === _elTarget[_i] ) {
								moveTo = _c.task ? -Math.abs(move) : Math.abs(move);
							}
						}

						target.style.transform = 'matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,' + moveTo + ',0.001,1)';

						if ( timeElapsed < duration ) {
							rafID = requestAnimationFrame(loop);
						} else {
							loopEnd();
						}
					}

					setTimeout(function () {
						rafID = requestAnimationFrame(function(time) { timeStart = time; loop(time); });
					}, 100);
				},

				// apply styles based on data-style-set attribute
				// @param {node} el Element with data-style-set attribute
				applySet : function(el, rule) {
					if  ( !(typeof el).match(/object/g) ) {
						var node = el;
						el = [];
						el.push(node);
					}

					var q = el.length;
					var max = el.length;
					while( q-- ) {
						if ( q < 0 ) { break; }
						var style = el[q].style;
						var set = JSON.parse(el[q].getAttribute('data-style-set'));
						var css = rule || /(top|left|height|width|position)/g;
						for ( var prop in set ) {
							if (prop.match(css)) {
								style[prop] = set[prop];
							}
						}
					}
				},

				// set styles and cache on data-style-set attribute
				// @param {array} arr array of nodes
				defineStyleSet : function(arr) {
					if  ( !(typeof arr).match(/object/g) ) {
						var node = arr;
						arr = [];
						arr.push(node);
					}

					var q = arr.length;
					var max = arr.length;
					while( q-- ) {
						if ( q < 0 ) {
							break;
						}
						var s = arr[q].getBoundingClientRect();
						arr[q].setAttribute('data-style-set', JSON.stringify({
							top : String(s.top + 'px'),
							left : String(s.left + 'px'),
							width : String(s.width + 'px'),
							height : String(s.height + 'px'),
							position : 'fixed'
						}));
					}
				},

				warn : function() {
					var _c = this;

					console.warn('curtain is ' + _c.state + '!');
					return;
				}
			};

			// init curtain triggers
			var curtainInit = function( e ) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();

				var off = _m.scroll.off;
				curtain.windowHeight = window.innerHeight || document.documentElement.clientHeight;

				// if curtain is not idle, animation cancel
				if ( curtain.started ) { curtain.warn(); return; }

				var _trigger = this;
				var _index = _trigger.getAttribute( 'data-index' );

				_trigger.setAttribute('disabled', '');
				_trigger.style.zIndex = '10';

				if ( curtain.activeIndex !== null && _index !== curtain.activeIndex ) {
					curtain.index = curtain.activeIndex;

					// if trigger state is 0/false, curtain action is open
					curtain.action = _elTrigger[ curtain.activeIndex ].btn.state ? 'close' : 'open';

					// prepare curtain animation
					curtain.prepare();
				}

				// monitor sequential task, run curtain.operate when completed
				_m.when(function condition(){
					var indx = curtain.activeIndex === null ? true : _index === curtain.activeIndex ? true : false;

					return indx;
				}, function code(){
					setTimeout(function () {
						curtain.index = _index;
						curtain.action = _trigger.btn.state ? 'close' : 'open';
						curtain.prepare();
					}, 200);
				});
			};

			// click listener
			var clickListener = function( _el ) {
				// bind click to triggers
				_el.addEventListener( 'click', curtainInit, false );
			};

			// add window/browser resize listener
			window.addEventListener("resize",  _m.debounce( function() {
				curtain.sm = window.matchMedia( "( max-width: 400px )" );
				curtain.md = window.matchMedia( "( min-width: 401px && max-width: 860px )" );
				curtain.lg = window.matchMedia( "( min-width: 861px && max-width: 1200px )" );
			}, 200));

			// cache frames
			_frames.push( document.querySelector( 'HTML' ) );
			_frames.push( document.querySelector( 'body' ) );
			_frames.push( document.querySelector( '.site-container' ) );

			// init bind click to triggers
			var total = _elTrigger.length;
			while( total-- ) {
				if ( total < 0) { break; }

				// add btn data
				_elTrigger[total].btn = {
					state: 0
				};

				//cache trigger container : li classname = ms-module--announcement__list-item
				_elContainer[total] = _m.getParents( _elTrigger[total], 'li' )[0];

				//cache target : article classname = ms-announcement-info
				_elTarget[total] = _elTrigger[total].parentNode.nextElementSibling;
				_elTarget[total].classList.add( 'collapsed' );

				//cache target content : div classname = ms-announcement-info__content
				_elTargetContent[total] = _elTarget[total].firstElementChild;

				// Add index on trigger and target and container
				_elContainer[total].setAttribute( 'data-index', total );
				_elTrigger[total].setAttribute( 'data-index', total );
				_elTarget[total].setAttribute( 'data-index', total );

				// add click listener on trigger
				clickListener(_elTrigger[total]);
			}

			var sharedAnnouncement = document.querySelector( '.shared' );
			var index = sharedAnnouncement ? sharedAnnouncement.getAttribute( 'data-index' ) : false;
			if ( index ) {
				curtain.index = index;

				curtain.action = _elTrigger[ index ].btn.state ? 'close' : 'open';

				setTimeout(function () {
					curtain.prepare();
				}, 1500);
			}


			// loader
			var setCirlceLoaderPercent = function(percent, stop, speed, $element){
				var intervalHandle = null;
				intervalHandle = setInterval(function() {
					if (percent === stop) {
						if (percent === 40){
							$element.addClass('progressing-40');
						}
						clearInterval(intervalHandle);
					}
					$('.ms-module--announcement__circle-percent').text(percent+'%');
					percent++;
				}, speed);
			};

			$('button.ms-module--announcement__trigger').on('click', function(){
				var $parent = $(this).parents('section');

				if ( $parent.parent('li').hasClass('expanded')){
					$('.ms-announcement-trigger', $parent).trigger('click');
					$parent.removeClass('triggered');
					return false;
				}

				$parent.addClass('triggered progressing');

				$('.c100', $parent).addClass('p40');
				setCirlceLoaderPercent(0,40,50,$parent);

					// trigger expandable content
				setTimeout(function() {
					setTimeout(function() {
						$parent.removeClass('progressing progressing-40');
						$('.c100', $parent).removeClass('p40');
					}, 1100);
					$('.ms-announcement-trigger', $parent).trigger('click');

				}, 7500);


			});


		},
		waypointHandler: function() {
			var firstElement = document.getElementsByClassName('ms-masterbrand')[0].firstElementChild;
			var nextElement = firstElement.nextElementSibling;
			var header = document.getElementById('header');
			var toggleNav = new Waypoint({
                element: nextElement,
                handler: function( direction ) {
						if ( direction.match( /up/g ) ) {
							header.classList.remove('enabled');
						} else if ( direction.match( /down/g ) ) {
							if ( !header.classList.contains('is-docked') ) {
								header.classList.add('is-docked');
							}
							if ( !header.classList.contains('enabled') ) {
								header.classList.add('enabled');
							}
						}
                },
                offset: $(window).height() / 2
            });

			var _elInfluencerTrigger = document.querySelectorAll( '.ms-influencer-trigger');
			var _elAnnouncementTrigger = document.querySelectorAll( '.ms-module--announcement__trigger');
			var _elAnnouncementTriggerHidden = document.querySelectorAll( '.ms-announcement-trigger');
			// set sticky trigger
			var stickyIn = function( el ) {
				new Waypoint({
					element: el,
					handler: function( direction ) {
						var container = _m.getParents( el, 'li' )[0];
						if ( container.classList.contains( 'expanded' ) ) {
							if ( direction.match( /up/g ) ) {
								el.classList.remove( 'stick' );
							} else if ( direction.match( /down/g ) ) {
								el.classList.add( 'stick' );
							}
						} else {
							el.classList.remove( 'stick' );
						}
					},
					offset: 60
				});
			};

			var stickyOut = function( el, index, elements ) {
				new Waypoint({
					element: el,
					handler: function( direction ) {
						if ( el.classList.contains( 'expanded' ) ) {
							if ( direction.match( /up/g ) ) {
								el.classList.remove( 'wrap' );
							} else if ( direction.match( /down/g) ) {
								el.classList.add( 'wrap' );
							}
						} else {
							el.classList.remove( 'wrap' );
						}
					},
					offset: function() {
						return -Math.abs(this.element.clientHeight) + 60 + elements[index].offsetHeight + 20;

					}
				});
			};

			var midCollapse = function( el ) {
				new Waypoint({
					element: el,
					handler: function( direction ) {
						var container = _m.getParents( el, 'li' )[0];
						if ( container.classList.contains( 'expanded' ) ) {
							if ( direction.match( /up/g ) ) {
								el.classList.remove( 'mid-collapse' );
							} else if ( direction.match( /down/g ) ) {
								el.classList.add( 'mid-collapse' );
							}
						} else {
							el.classList.remove( 'mid-collapse' );
						}
					},
					offset: 60
				});
			};

			var applySticky = function (_el) {
				var o = _el.length;
				if (!_el.length){ return; }
				while(o--) {
					stickyOut( _m.getParents( _el[o], 'li' )[0], o, _el );
					stickyIn( _el[o] );
					midCollapse( _el[o].parentNode.nextElementSibling );
				}
			};

			applySticky( _elInfluencerTrigger );
			applySticky( _elAnnouncementTrigger );
			applySticky( _elAnnouncementTriggerHidden );

		},
		carouselHandler: function () {
			// -hero module
			jQuery('.ms-module--carousel__content').each(function(){
				var $heroSlider = jQuery( this );
				var $heroSliderItem = jQuery( '.ms-module--carousel__item', $heroSlider );

				$heroSlider.slick();
				var $status = $heroSlider.next('.pagination');
				$heroSlider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
						var i = (currentSlide ? currentSlide : 0) + 1;
						$status.text(i + ' / ' + slick.slideCount);
				});

			});

			jQuery('.ms-splash--carousel').each(function(){
				var $carouselSlider = jQuery( this );
				//var $heroSliderItem = jQuery( '.ms-module--carousel__item', $heroSlider );

				$carouselSlider.slick();
				var $status = $carouselSlider.next('.pagination');
				$carouselSlider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
						var i = (currentSlide ? currentSlide : 0) + 1;
						$status.text(i + ' / ' + slick.slideCount);
				});

			});

			$('.fw-cta-carousel-item[data-slick-index]').on('click', function(e) {
				e.preventDefault();
				var slideNo = $(this).data('slickIndex');
				$(this).parents('.ms-module--carousel__content').slick('slickGoTo', slideNo);
			}).on('click','a',function(e) {
        e.stopPropagation();
   		});



			// -social module
			var $container = document.querySelector( '.ms-module--social__list' );
			var $socialSlider = jQuery( '.ms-module--social__list' );
			var $socialSliderItem = jQuery( '.ms-module--social__list-item' );
			var slick = false;
			var slickInit = false;

			// debounce: every after resizing, trigger this
			var socialCarousel = _m.debounce( function() {
				var sm = window.matchMedia( "( max-width: 400px )" );
				if ( sm.matches ) { // if on small breakpoint
					if ( slick ) {
						$container.style.opacity = 1;
						return;
					}
					$socialSlider.slick({
						arrows: false,
						dots: false,
						infinite: true,
						speed: 300,
						slidesToShow: 1,
						slidesToScroll: 1,
						variableWidth: true
					});
					slickInit = true;
					slick = true;
					$container.style.opacity = 1;
				} else { // if not on small breakpoint
					if ( !slickInit ) {
						$container.style.opacity = 1;
						return;
					}
					slick = false;
					$socialSlider.slick( 'unslick' );
					$container.style.opacity = 1;
				}
			}, 300);

			_m.ready(function() {
				// social carousel init
				socialCarousel();

				// add window/browser resize listener
				window.addEventListener("resize", function() {
					$container.style.opacity = 0;
					socialCarousel();
				});
				$(window).trigger('resize');
			});
		},
		scrollToHandler: function( options ) {

			var _trigger = document.querySelectorAll( '.js-scroll-next' );

			var trigger_handler = function (e) {
				e.preventDefault();
				e.stopPropagation();

				var _elTrigger = this;
				var _elTarget = document.querySelector(_elTrigger.getAttribute( 'data-target' ));

				_m.jump(_elTarget, {
					duration: 900,
					offset: -60
				});
			};

			var total = _trigger.length;
			while(total--) {
				_trigger[total] =
				_trigger[total].addEventListener( 'click', trigger_handler, false );

				if ( !total ) {
					break;
				}
			}
		},
		shareScrollHandler: function() {
			if ( !$('.js-share-scroll').length ) { return false; }
			setTimeout(function(){
				$('.js-share-scroll').trigger('click');

			}, 1500);
		},
		influencerGalleryHandler: function() {
			$('.ms-ts-gallery-module__images').slick();

			var $status = $('.ms-ts-gallery-module__nav span.page');
			$('.ms-ts-gallery-module__images').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
			    var i = (currentSlide ? currentSlide : 0) + 1;
			    var $gallery = $(this);
			    $status.text(i + '/' + slick.slideCount);

			    var $activeVideo = $('.video--active').first();
			    if( $activeVideo.length > 0 ) {
			    	var video = $activeVideo.find('.the-video').html();
			    	$activeVideo.find('.the-video').html(video);
			    	$activeVideo.removeClass('video--active');
			    }
			});

			$('.ms-ts-gallery-module__images').on('click', '.video > a', function(event) {
				event.preventDefault();
				$trigger = $(this);
				$parent = $trigger.parents('.video').first();
				$parent.addClass('video--active');
			});
		},
		parallaxHandler: function() {
			var toggleParallax = _m.debounce( function() {
				if ( window.Modernizr.touch ) {
					var i = skrollr.get();

					if ( i ) {
						skrollr.destroy();
					}
				} else {
					skrollr.init({
						forceHeight: false,
						easing: {
							easeOutElasticBig: function(p) {
								return 56*(p*p*p*p*p) - 175*(p*p*p*p) + 200*(p*p*p) - 100*(p*p) + 20*p;
							}
						},
						smoothScrollingDuration: 100
					});
				}
			}, 300);

			toggleParallax();

			window.addEventListener("resize", function() {
				toggleParallax();
			});
		},
		contentAnimationHandler: function() {
			var contents = document.querySelectorAll(".ms-content-animation");
			var o = contents.length;
			var animateContents = function( el ) {
				// var _offset = el.getAttribute('data-offset') ? parseInt(el.getAttribute('data-offset')) : 200;
				var _offset = '70%';
				new Waypoint({
					element: el,
					handler: function(direction) {
						if( !el.classList.contains( 'animated' ) ) {
							el.classList.add( 'animated' );
						} else if( direction.match( /up/g ) ) {
							//if( MS.masterbrand.pageLoaded ) {
								el.classList.remove( 'animated' );
							//} else {
							//	MS.masterbrand.pageLoaded = true;
							//	el.classList.remove( 'quick-view' );
							//}

						}
					},
					offset: _offset
				});
			};
			while(o--) {
				var content = contents[o];
				animateContents(content);
			}
		},
		sharing: function() {
			$(".ms-share-link").on("click", function(e){
				e.preventDefault();

				var ms_popup;
				var ms_href = $(this).attr('href');
				var ms_dt = $(this).attr('data-track');

				ms_popup = ($(this).hasClass("pn"))? window.open(ms_href, 'Share', 'height=600,width=800') : window.open(ms_href, 'Share', 'height=325,width=600');

				ga('send', 'event', 'button', 'click', ms_dt);

				if (window.focus) {
					ms_popup.focus();
				}
			});
		},
		olapicHandler: function(obj){
			if ( !$('#olapic_specific_widget').length ) { return; }
			if ( obj == null ) { return; }

			if ( !obj.pages.next ){
				$('.olapic-loadmore').hide().remove();
			}
		}


	};
})( jQuery, masterbrand, skrollr );

MS.masterbrand.init();
